import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardFeature } from "@/lib/policy/route-guard";
import { SuppliesGate } from "./-components/supplies-gate";
import { SuppliesTabs } from "./-components/supplies-tabs";

/** Supplies: the building's supply closet, its running list and the products to buy. */
export const Route = createFileRoute("/_authenticated/supplies")({
  beforeLoad: ({ context }) => guardFeature(context.me, "supplies"),
  head: () => ({
    meta: [
      { title: "Supplies | People AI" },
      {
        name: "description",
        content: "The supply closet, the supplies list and the products to buy.",
      },
    ],
  }),
  component: SuppliesLayout,
});

function SuppliesLayout() {
  return (
    <div className="w-full min-w-0 space-y-5">
      <PageHeader title="Supplies" meta="Keep the closet counted, and see what to buy" />
      <SuppliesGate>
        <SuppliesTabs />
        <Outlet />
      </SuppliesGate>
    </div>
  );
}
